<template>
    <div class="container mx-auto">
        <!-- logo -->
        <div class="flex flex-col items-center justify-center">
            <img class="w-32" src="../assets/logo-megaluzz.png" alt="Megaluzz Logo">
        </div>

        <div class="flex justify-center mb-6" v-if="loading">
            <Loading text="Buscando atividades... ..." :show="loading" />
        </div>

        <!-- Header-->
        <div class="flex flex-col gap-y-2 items-center justify-center mt-4">
            <h1 class="text-green-600 font-bold text-base uppercase">{{ dispatch.company?.name }}</h1>
            <h1
                v-if="form.form_body?.type !== 'climate'"
                class="text-green-700 font-semibold text-sm uppercase"
            >
                Olá {{ dispatch.receiver?.name || '--' }}, responda a(s) perguntas a seguir:
            </h1>
            <p
                v-else
                class="text-green-600 font-semibold text-sm uppercase"
            >
                Esta pesquisa é anônima. Responda com sinceridade, suas respostas não serão identificadas.
            </p>
			<h1 v-if="form.form_body?.type === '360'" class="text-green-600 font-bold text-base uppercase">Avaliação 360</h1>
        </div>

        <div :class="{ 'bg-green-100 border border-green-700': field.lock }" v-for="field in form.form_body?.structure" :key="field.uuid" class="flex bg-white p-4 rounded-md mt-4 border border-gray-300">
            <div class="flex flex-col flex-1">
                <h1 v-if="field.lock" class="text-red-400 mb-2 font-bold text-sm">Pergunta oculta, apenas a Megaluzz pode ver e responder</h1>
                <!-- LABEL -->
                <h1 v-if="field.type !== 'static_text'" class="text-green-600 mb-2 font-bold text-base">
                    {{ field.label }}
                    <small v-if="field.required" class="text-red-500">*</small>
                </h1>
                <p v-else class="text-gray-700 text-base whitespace-pre-line">{{ field.label }}</p>
                <!--INPUT BASICO-->
                <BaseInput v-if="field.type === 'text'" class="flex-1" v-model="field.answer" />
                <!--INPUT EMAIL-->
                <BaseInput v-if="field.type === 'email'" class="flex-1" type="email" v-model="field.answer" />
                <p v-if="field.type !== 'static_text' && invalidFields.has(field.uuid)" class="text-red-500 text-sm mt-1">Este campo é obrigatório</p>

                <!-- TEXTAREA-->
                <BaseTextarea v-if="field.type === 'long_text'" rows="5" v-model="field.answer" />
                
                <!-- Antigo Radio Button que era coluna -->
                <!-- <div class="flex flex-col gap-y-4" v-if="field.type === 'multiple_choice'">
                    <div class="flex flex-col gap-x-2 mt-4" v-for="option in field.options" :key="option.uuid">
                        <div class="flex gap-x-2">
                            <BaseRadio class="flex gap-x-2" :value="option.label" :label="option.label" :name="field.uuid" v-model="field.answer" />
                        </div>
                    </div>
                </div> -->
				<!-- Radio Button -->
				<div class="flex flex-col gap-y-4 items-center" v-if="field.type === 'multiple_choice' || field.type === 'scale'">
					<div class="flex flex-wrap gap-x-6 gap-y-4 mt-4">
						<div v-for="option in field.options" :key="option.uuid" class="flex items-center gap-x-1">
							<BaseRadio
								:value="option.label"
								:label="option.label"
								:name="field.uuid"
								v-model="field.answer"
							/>
						</div>
					</div>
				</div>
                <!-- Checkbox-->
                <div class="flex flex-col gap-y-4" v-if="field.type === 'checkbox'">
                    <label class="label">{{ field.label }}</label>
                    <div class="flex flex-col gap-x-2 mt-4" v-for="option in field.options" :key="option.uuid">
                        <div class="flex gap-x-2">
                            <BaseCheckbox :label="option.label" v-model="option.answer" />
                        </div>
                    </div>
                </div>
                <!-- SELECT-->
                <div class="flex flex-col gap-y-4" v-if="field.type === 'select'">
                    <BaseSelect :options="parseSelectOptions(field.options)" v-model="field.answer" class="w-6/12" />
                </div>
            </div>
        </div>

        <div v-if="dispatch.is_valid" class="flex justify-center mt-6">
            <button :disabled="loadingSubmit" @click="submitForm" class="bg-green-600 text-white px-6 py-4 rounded-md disabled:bg-gray-400 hover:bg-green-700 w-full">
                <div class="flex gap-x-2 justify-center">
                    <svg v-if="loadingSubmit" class="animate-spin mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Enviar
                </div>
            </button>
        </div>
    </div>
</template>

<script>
    import { ref, onMounted } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import Swal from 'sweetalert';
    import { FormService, DispatchService } from '../services/Entity';
    import { defaultDate } from '../filters/date';

    export default {
        name: 'Forms',
        components: {
        },
        setup() {
            const page = ref(1);
            const limit = ref(20);
            const totalItens = ref(0);
            const loading = ref(false);
            const route = useRoute();
            const router = useRouter();
            const form = ref({});
            const dispatch = ref({});
            const invalidFields = ref(new Set());
            const loadingSubmit = ref(false);

            onMounted(async () => {
                const formUUID = route.params.form_uuid || null;
                const dispatchUUID = route.params.dispatch_uuid || null;

                if (!formUUID && !dispatchUUID) {
                    Swal({
                        title: 'Este link é inválido ou está expirado',
                        text: 'Solicite outro',
                        icon: 'info'
                    });
                    setTimeout(function() {
                        window.location.href = 'https://megaluzz.com.br/';
                    }, 3000)
                    return;
                }

                if (formUUID) {
                    form.value = await getFormByUUID(formUUID);

                    form.value.form_body.structure.forEach(field => {
                        if (field.type === 'checkbox') {
                            field.options.forEach(opt => {
                                opt.answer = !!opt.answer;
                            });
                        }
                    });
                }

                if (dispatchUUID) {
                    const { data } = await DispatchService.getPublicByUUID(dispatchUUID);

                    if (!data.uuid || !data.is_valid) {
                        Swal({
                            title: 'Este link é inválido ou está expirado',
                            text: 'Solicite outro',
                            icon: 'info'
                        });

                        setTimeout(function() {
                            window.location.href = 'https://megaluzz.com.br/';
                        }, 3000)
                        return;
                    }

                    dispatch.value = data;

                    // Atualiza o form a partir da estrutura vinda no dispatch
                    form.value = {
                        form_body: data.form_structure
                    };

                    // Marca checkbox como boolean
                    form.value.form_body.structure.forEach(field => {
                        if (field.type === 'checkbox') {
                            field.options.forEach(opt => {
                                opt.answer = !!opt.answer;
                            });
                        }
                    });
                }
            });

            async function submitForm() {
                invalidFields.value.clear(); // limpa erros anteriores
                let hasError = false;

                form.value.form_body.structure.forEach(field => {
                    if (field.required) {
                        if (field.type === 'static_text') {
                            return;
                        }
                        if (field.type === 'checkbox') {
                            const checked = field.options.some(opt => opt.answer === true);
                            if (!checked) {
                                invalidFields.value.add(field.uuid);
                                hasError = true;
                            }
                        } else {
                            if (!field.answer || field.answer === '') {
                                invalidFields.value.add(field.uuid);
                                hasError = true;
                            }
                        }
                    }
                });

                if (hasError) {
                    Swal({
                        title: 'Formulário incompleto',
                        text: 'Preencha os campos obrigatórios destacados em vermelho.',
                        icon: 'warning'
                    });
                    return;
                }

                try {
                    const uuid = dispatch.value.uuid;
                    const form_structure = form.value.form_body;

                    loadingSubmit.value = true;
                    await DispatchService.submit(uuid, { form_structure });
                    loadingSubmit.value = false;

                    router.push({ name: 'thanks' });
                } catch (err) {
                    loadingSubmit.value = false;
                    console.error('Erro ao enviar formulário:', err);
                    Swal({
                        title: 'Erro ao enviar',
                        text: 'Ocorreu um erro ao tentar enviar o formulário. Tente novamente mais tarde.',
                        icon: 'error'
                    });
                }

                router.push({ name: 'thanks' });
            }

            async function getFormByUUID(uuid) {
                try {
                    loading.value = true;
                    const { data } = await FormService.getById(uuid);
                    loading.value = false;
                    
                    return data;
                } catch(err) {
                    loading.value = false;
                    console.log(err);
                    Swal({
                        title: 'Ocorreu um erro',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }

            function parseSelectOptions(options = []) {
                return options.map(opt => ({
                    title: opt.label,
                    value: opt.label
                }));
            }

            return {
                loadingSubmit,
                page,
                limit,
                submitForm,
                dispatch,
                totalItens,
                loading,
                defaultDate,
                parseSelectOptions,
                invalidFields,
                form
            }
        }
    }

</script>
